export default "__VITE_ASSET__DAadBQd8__"